module.exports = __webpack_public_path__ + "static/media/swift.d7945167.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/swift.png
// module id = 201
// module chunks = 0